import { useState } from "react";
import { Button } from "react-bootstrap";
import Form from "react-bootstrap/Form";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { loginAdmin } from "../../controller/index";
import { requestHandler } from "../../helper";

function Login() {
    const [showPassword, setShowPassword] = useState(false);
    const navigate = useNavigate();
    const [userData, setUserData] = useState({
        email: "",
        password: "",
    });

    const handleFormData = (e) => {
        e.preventDefault();
        setUserData({
            ...userData,
            [e.target.name]: e.target.value,
        });
    };

    const togglePasswordVisibility = () => {
        setShowPassword(!showPassword);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!userData?.email) {
            toast.error("Enter email");
            return;
        }

        if (
            !/^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(
                userData?.email
            )
        ) {
            toast.error("Enter valid email");
            return;
        }

        if (!userData?.password) {
            toast.error("Enter password");
            return;
        }

        // console.log(userData, "userData");

        await requestHandler(
            async () => await loginAdmin(userData),
            null,
            (res) => {
                const { data } = res;
                // setToken(data.token);
                // setUser(data.email);
                toast.success(res.message);
                localStorage.setItem("token", data.token);
                localStorage.setItem("user", JSON.stringify(data.user.email));
                localStorage.setItem(
                    "userName",
                    JSON.stringify(data?.user?.userName || "")
                );
                navigate("/dashboard");
            },
            () => { }
        );
    };

    return (
        <>
            <section className="auth-main">
                <div className="container">
                    <div className="row justify-content-center align-content-center vh-100">
                        <div className="col-12 col-md-8 col-lg-7 col-xl-6">
                            <div className="d-flex justify-content-center">
                                <img
                                    src="../images/png/login.png"
                                    className="logo-img"
                                    width={183}
                                    height={120.95}
                                    alt=""
                                />
                            </div>
                            <div className="card">
                                <div className="card-body">
                                    <h2>Sign in</h2>
                                    <p
                                        className="text-center mx-auto"
                                    >
                                        Sign in to your account using email and password
                                        provided during registration.
                                    </p>
                                    <Form onSubmit={handleSubmit}>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="formGroupEmail"
                                        >
                                            <Form.Label>Email</Form.Label>
                                            <Form.Control
                                                type="email"
                                                name="email"
                                                placeholder="Enter email"
                                                value={userData.email}
                                                onChange={handleFormData}
                                            />
                                        </Form.Group>
                                        <Form.Group
                                            className="mb-3"
                                            controlId="formGroupPassword"
                                        >
                                            <Form.Label>Password</Form.Label>
                                            <div className="form-control d-flex align-items-center ps-0 py-0">
                                                <Form.Control
                                                    type={
                                                        showPassword
                                                            ? "text"
                                                            : "password"
                                                    }
                                                    placeholder="Enter Password"
                                                    name="password"
                                                    className="border-0"
                                                    value={userData.password}
                                                    onChange={handleFormData}
                                                />
                                                <img
                                                    width={22}
                                                    src={
                                                        showPassword
                                                            ? "../images/png/show-eye.png"
                                                            : "../images/png/close-eye.png"
                                                    }
                                                    alt=""
                                                    style={{
                                                        cursor: "pointer",
                                                    }}
                                                    onClick={
                                                        togglePasswordVisibility
                                                    }
                                                />
                                            </div>
                                            {/* <Link
                                                to="/forget-password"
                                                className="forgot-password"
                                            >
                                                Forgot Password?
                                            </Link> */}
                                        </Form.Group>
                                        <Button
                                            className="button"
                                            type="submit"
                                        >
                                            Sign In
                                        </Button>
                                    </Form>
                                    {/* <h6>
                                        Don’t have an account ?{" "}
                                        <Link to="/register">Register</Link>
                                    </h6> */}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
}

export default Login;
